/*
 * flash-sale.js — app-driven flash-sale banner (reference: FlashSaleBanner.tsx).
 *
 * Fetches the app's public active flash sales ({base}/flash-sales, CORS
 * allow-listed like top-djs) and renders ONLY the first (earliest-ending) sale:
 * gold lightning pill + "{value}% OFF" / "{value} AED OFF" + localized sale
 * name + a live 1s countdown (days tile only when > 0) + a gold shop CTA.
 * Exactly like the app, the banner renders nothing when there is no active
 * sale, hides itself the moment the countdown reaches zero, and stays silent
 * on any fetch error. No money beyond the public discount value, no ids
 * beyond the sale id, and no buyer data ever reach this DOM.
 */
(function () {
  'use strict';

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) { node.className = className; }
    return node;
  }

  function timeLeft(endsAt) {
    var diff = new Date(endsAt).getTime() - Date.now();
    if (!(diff > 0)) { return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 }; }
    return {
      total: diff,
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff / 3600000) % 24),
      minutes: Math.floor((diff / 60000) % 60),
      seconds: Math.floor((diff / 1000) % 60)
    };
  }

  function pad(n) {
    return String(n).length < 2 ? '0' + n : String(n);
  }

  function unit(value, label) {
    var box = el('div', 'flash-sale__unit');
    var num = el('span', 'flash-sale__unit-value');
    num.textContent = pad(value);
    var cap = el('span', 'flash-sale__unit-label');
    cap.textContent = label;
    box.appendChild(num);
    box.appendChild(cap);
    return box;
  }

  function bolt() {
    var span = el('span', 'flash-sale__bolt');
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>';
    return span;
  }

  function render(section, sale, labels, locale, ctaUrl) {
    var name = locale === 'ar' && sale.name_ar ? sale.name_ar : sale.name;
    var value = Number(sale.discountValue);
    var offLabel = sale.discountType === 'percentage'
      ? value + '% ' + labels.off
      : value + ' AED ' + labels.off;

    var card = el('div', 'flash-sale');
    var pulse = el('div', 'flash-sale__pulse');
    pulse.setAttribute('aria-hidden', 'true');
    card.appendChild(pulse);

    var inner = el('div', 'flash-sale__inner');

    var info = el('div', 'flash-sale__info');
    var badges = el('div', 'flash-sale__badges');
    var pill = el('span', 'flash-sale__pill');
    pill.appendChild(bolt());
    pill.appendChild(document.createTextNode(labels.title));
    badges.appendChild(pill);
    var off = el('span', 'flash-sale__off');
    off.textContent = offLabel;
    badges.appendChild(off);
    info.appendChild(badges);
    var heading = el('h3', 'flash-sale__name');
    heading.textContent = name == null ? '' : String(name);
    info.appendChild(heading);
    inner.appendChild(info);

    var timer = el('div', 'flash-sale__timer');
    var ends = el('span', 'flash-sale__ends');
    ends.textContent = labels.ends;
    timer.appendChild(ends);
    var units = el('div', 'flash-sale__units');
    timer.appendChild(units);
    inner.appendChild(timer);

    var cta = el('a', 'flash-sale__cta');
    cta.href = ctaUrl;
    cta.textContent = labels.shop + ' →';
    inner.appendChild(cta);

    card.appendChild(inner);

    var slot = section.querySelector('.flash-sale-slot__inner');
    slot.appendChild(card);
    section.hidden = false;

    function tick() {
      var left = timeLeft(sale.endsAt);
      if (left.total <= 0) {
        clearInterval(intervalId);
        section.hidden = true;
        if (card.parentNode) { card.parentNode.removeChild(card); }
        return;
      }
      units.textContent = '';
      if (left.days > 0) { units.appendChild(unit(left.days, labels.days)); }
      units.appendChild(unit(left.hours, labels.hours));
      units.appendChild(unit(left.minutes, labels.minutes));
      units.appendChild(unit(left.seconds, labels.seconds));
    }

    var intervalId = setInterval(tick, 1000);
    tick();
  }

  function init() {
    var section = document.querySelector('[data-flash-sale]');
    if (!section) { return; }

    var base = (section.getAttribute('data-base') || '').trim();
    if (!base) { return; }

    var labels = {
      title: section.getAttribute('data-label-title') || '',
      off: section.getAttribute('data-label-off') || '',
      shop: section.getAttribute('data-label-shop') || '',
      ends: section.getAttribute('data-label-ends') || '',
      days: section.getAttribute('data-label-days') || '',
      hours: section.getAttribute('data-label-hours') || '',
      minutes: section.getAttribute('data-label-minutes') || '',
      seconds: section.getAttribute('data-label-seconds') || ''
    };
    var locale = (section.getAttribute('data-locale') || 'en').trim();
    var ctaUrl = section.getAttribute('data-cta-url') || '/collections/all';

    fetch(base.replace(/\/+$/, '') + '/flash-sales', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.sales) || data.sales.length === 0) { return; }
        var sale = data.sales[0];
        if (!sale || !sale.endsAt || timeLeft(sale.endsAt).total <= 0) { return; }
        render(section, sale, labels, locale, ctaUrl);
      })
      .catch(function () { /* no sale banner on error — matches the app's null render */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
